import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsPageComponent } from './pages/gestione-dipartimenti/departments-page/departments-page.component';
import { DetailDepartmentPageComponent } from './pages/gestione-dipartimenti/detail-department-page/detail-department-page.component';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { authGuardLEMFn } from 'src/app/guards/auth.guard-lem';


const routes: Routes = [
  {
    path: '',
    data: { descrittore: NomiDescrittoriSezione.DESCRITTORE_DIPARTIMENTI },
    canActivate: [authGuardLEMFn],
    canActivateChild: [authGuardLEMFn],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: DepartmentsPageComponent,
      },
      {
        path: 'dettaglio/:id',
        data: {title: "Dipartimenti - dettaglio"},
        component: DetailDepartmentPageComponent
      }
    ]
  }
];

@NgModule({
  declarations: [

  ],
  imports: [
    RouterModule.forChild(routes),

  ],
  exports: [RouterModule]
})
export class DipartimentiRoutingModule { }
